import { Link, NavLink } from "react-router-dom";
import trustedLogoAlt from "../assets/images/trustedLogoAlt.svg";

function Footer() {
	return (
		<footer>
			<nav className="footerNavBar">
				<NavLink className="link logo headerLogo" to="/">
					<img alt="GCAS Regina" src={trustedLogoAlt} />
				</NavLink>
				<ul className="navItems">
					<li>
						<Link className="footerNavItem" href="/privacy-policy">
							Privacy Policy
						</Link>
					</li>
					<li>
						<Link className="footerNavItem" href="/terms-and-conditions">
							Terms and Conditions
						</Link>
					</li>
				</ul>
				<div className="socials">
					<Link
						href="https://www.instagram.com/yourprofile"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="Visit our Instagram profile"
					>
						<i className="fa-brands fa-instagram"></i>
					</Link>
					<Link
						href="https://wa.me/yourphonenumber"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="Chat with us on WhatsApp"
					>
						<i className="fa-brands fa-whatsapp"></i>
					</Link>
					<Link
						href="https://www.facebook.com/yourpage"
						target="_blank"
						rel="noopener noreferrer"
						aria-label="Visit our Facebook page"
					>
						<i className="fa-brands fa-facebook"></i>
					</Link>
				</div>
			</nav>
			<hr />
			<p className="copyright">
				&copy; Copyright 2025 | All Rights Reserved | Trusted Counseling and
				Consultancy &trade;
			</p>
		</footer>
	);
}

export default Footer;
